import { render, staticRenderFns } from "./trakt-authentication.vue?vue&type=template&id=769fed2d&scoped=true"
import script from "./trakt-authentication.vue?vue&type=script&lang=js"
export * from "./trakt-authentication.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769fed2d",
  null
  
)

export default component.exports